module.exports = __webpack_public_path__ + "img/cube-big.d585b956.svg";